import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_SPECIAL_OFFER_DURATION': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
